<script setup lang="ts">
import { onUnmounted, watch } from 'vue';
import { useModalManager } from '@src/shared/lib/composables/useModalManager';
import BaseModal from '@src/shared/ui/BaseModal.vue';

const { modalStack, closeModal } = useModalManager();

watch(
	() => modalStack.value.length,
	(length) => {
		document.body.style.overflow = length > 0 ? 'hidden' : '';
	},
	{ immediate: true },
);

onUnmounted(() => {
	document.body.style.overflow = '';
});
</script>

<template>
	<Teleport to="body">
		<TransitionGroup name="modal-fade">
			<BaseModal
				v-for="modal in modalStack"
				:key="modal.id"
				:closable-on-backdrop="modal.options.closableOnBackdrop"
				:closable-on-esc="modal.options.closableOnEsc"
				@close="closeModal(modal.id)"
			>
				<component :is="modal.component" v-bind="modal.props" />
			</BaseModal>
		</TransitionGroup>
	</Teleport>
</template>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition:
		opacity 0.2s ease,
		transform 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
	opacity: 0;
	transform: scale(0.98);
}
</style>
